import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://sergeylevitskiy.com';

const SEO = ({ 
  title, 
  description, 
  image,
  type = 'website',
  keywords 
}) => {
  const location = useLocation();
  
  // Получаем текущий домен (работает и в dev, и в production)
  const getBaseUrl = () => {
    if (typeof window !== 'undefined') {
      return window.location.origin;
    }
    return SITE_URL;
  };
  
  const baseUrl = getBaseUrl();
  const currentUrl = `${baseUrl}${location.pathname}`;
  
  // Всегда просто "Sergey Levitskiy" во вкладке браузера
  const fullTitle = 'Sergey Levitskiy';
  
  // Всегда используем фото с splash screen для всех страниц
  // Используем абсолютный URL для Open Graph и Twitter Card
  const seoImage = `${baseUrl}/images/main-photo.jpg`;
  
  // Отладка: выводим URL изображения в консоль
  if (process.env.NODE_ENV === 'development') {
    console.log('🖼️ SEO Image URL:', seoImage);
  }
  
  const fullDescription = description || 
    'Sergey Levitskiy - Professional DJ and Music Producer. Commercial and Underground Electronic Music. Book for events, weddings, and special occasions.';
  
  const fullKeywords = keywords || 
    'Sergey Levitskiy, DJ, Music Producer, Electronic Music, Commercial DJ, Underground Music, Event DJ, Wedding DJ';

  return (
    <Helmet>
      {/* Основные SEO теги */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={currentUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:secure_url" content={seoImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:site_name" content="Sergey Levitskiy" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="ru_RU" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:image:src" content={seoImage} />
    </Helmet>
  );
};

export default SEO;

